// BoxingUnited Premium Theme — JS
document.addEventListener('DOMContentLoaded', function() {
  // Smooth reveal on scroll
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.adn-card, .product-card').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });
});

// Mobile menu
const menuToggle = document.getElementById('MenuToggle');
const menuClose = document.getElementById('MenuClose');
const mobileMenu = document.getElementById('MobileMenu');
const menuOverlay = document.getElementById('MenuOverlay');

function openMenu() {
  mobileMenu && mobileMenu.classList.add('open');
  menuOverlay && menuOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMenu() {
  mobileMenu && mobileMenu.classList.remove('open');
  menuOverlay && menuOverlay.classList.remove('open');
  document.body.style.overflow = '';
}

menuToggle && menuToggle.addEventListener('click', openMenu);
menuClose && menuClose.addEventListener('click', closeMenu);
menuOverlay && menuOverlay.addEventListener('click', closeMenu);

// Option buttons
document.querySelectorAll('.product-option__values').forEach(function(group) {
  group.querySelectorAll('.option-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      group.querySelectorAll('.option-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });
});
